<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default Vue.component('Accordion', {
        name: 'Accordion',
        props: {
            // used to scroll only after the content is loaded
            contentLoadingData: {
                type: Object,
                default: null,
            },
        },
        data() {
            return {
                active: null,
                oldActive: null
            };
        },
        watch: {
            'active.index': function () {
                this.scrollOffset = this.getScrollOffset();
                if (!this.contentLoadingIndicator) {
                    this.scroll();
                }
            },
            'contentLoadingData.isContentLoaded': function (value) {
                if (value) {
                    this.scroll();
                }
            }
        },
        created() {
            this.uuid = 0;
        },
        methods: {
            setActive(active) {
                if (!this.active || this.active.index !== active.index) {
                    this.oldActive = this.active;
                    this.active = active;
                    this.$emit('expand', active.index);
                } else {
                    this.active = null;
                }
            },
            setActiveHeight(height) {
                this.active.height = height;
            },
            getUuid() {
                const id = this.uuid;
                this.uuid += 1;
                return id;
            },
            getScrollOffset() {
                if (this.active && this.oldActive && this.oldActive.index < this.active.index) {
                    return -this.oldActive.height;
                }
                return 0;
            },
            scroll() {
                window.scrollBy(0, this.scrollOffset);
                this.scrollOffset = 0;
            }
        },
    });
</script>


// WEBPACK FOOTER //
// src/app/modules/shared/components/accordion/Accordion.vue